import _classCallCheck from "/codebuild/output/src850585749/src/natashamanger.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src850585749/src/natashamanger.com/node_modules/@babel/runtime/helpers/esm/createClass";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var MoveAngle = /*#__PURE__*/function () {
  function MoveAngle() {
    _classCallCheck(this, MoveAngle);
    this.offset = 0;
    this.value = 90;
  }
  _createClass(MoveAngle, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.offset !== undefined) {
        this.offset = setRangeValue(data.offset);
      }
      if (data.value !== undefined) {
        this.value = setRangeValue(data.value);
      }
    }
  }]);
  return MoveAngle;
}();